<div class="container">
  <mat-stepper
    orientation="vertical"
    [linear]="false"
    class="mat-elevation-z8"
    labelPosition="bottom"
    #loanProductStepper
  >
    <ng-template matStepperIcon="number">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="edit">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="done">
      <fa-icon icon="check" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="error">
      <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="preview">
      <fa-icon icon="eye" size="sm"></fa-icon>
    </ng-template>

    <mat-step [stepControl]="loanProductDetailsForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.DETAILS' | translate }}</ng-template>

      <LOSx-loan-product-details-step
        [loanProductsTemplate]="loanProductAndTemplate"
      ></LOSx-loan-product-details-step>
    </mat-step>

    <mat-step [stepControl]="loanProductCurrencyForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.CURRENCY' | translate }}</ng-template>

      <LOSx-loan-product-currency-step
        [loanProductsTemplate]="loanProductAndTemplate"
      ></LOSx-loan-product-currency-step>
    </mat-step>

    <mat-step [stepControl]="loanProductSettingsForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.SETTINGS' | translate }}</ng-template>

      <LOSx-loan-product-settings-step
        [loanProductsTemplate]="loanProductAndTemplate"
        [isLinkedToFloatingInterestRates]="loanProductTermsForm.get('isLinkedToFloatingInterestRates')"
        (advancePaymentStrategy)="advancePaymentStrategy($event)"
      >
      </LOSx-loan-product-settings-step>
    </mat-step>

    @if (isAdvancedPaymentStrategy) {
      <mat-step [stepControl]="loanProductInterestRefundForm" completed>
        <ng-template matStepLabel>{{ 'labels.inputs.INTEREST REFUND' | translate }}</ng-template>
        <LOSx-loan-product-interest-refund-step
          [loanProductsTemplate]="loanProductAndTemplate"
          (supportedInterestRefundTypes)="setSupportedInterestRefundTypes($event)"
        >
        </LOSx-loan-product-interest-refund-step>
        <LOSx-stepper-buttons></LOSx-stepper-buttons>
      </mat-step>
    }

    @if (isAdvancedPaymentStrategy) {
      <mat-step completed>
        <ng-template matStepLabel>{{ 'labels.inputs.PAYMENT ALLOCATION' | translate }}</ng-template>
        <LOSx-loan-product-payment-strategy-step
          [advancedPaymentAllocations]="advancedPaymentAllocations"
          [advancedCreditAllocations]="advancedCreditAllocations"
          [advancedPaymentAllocationTransactionTypes]="loanProductAndTemplate.advancedPaymentAllocationTransactionTypes"
          [paymentAllocationOrderDefault]="loanProductAndTemplate.advancedPaymentAllocationTypes"
          [advancedCreditAllocationTransactionTypes]="loanProductAndTemplate.creditAllocationTransactionTypes"
          [creditAllocationOrderDefault]="loanProductAndTemplate.creditAllocationAllocationTypes"
          (setPaymentAllocation)="setPaymentAllocation($event)"
          (setCreditAllocation)="setCreditAllocation($event)"
        >
        </LOSx-loan-product-payment-strategy-step>
        <LOSx-stepper-buttons></LOSx-stepper-buttons>
      </mat-step>
    }

    <mat-step [stepControl]="loanProductTermsForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.TERMS' | translate }}</ng-template>

      <LOSx-loan-product-terms-step [loanProductsTemplate]="loanProductAndTemplate"></LOSx-loan-product-terms-step>
    </mat-step>

    <mat-step completed>
      <ng-template matStepLabel>{{ 'labels.inputs.CHARGES' | translate }}</ng-template>

      <LOSx-loan-product-charges-step
        [loanProductsTemplate]="loanProductAndTemplate"
        [currencyCode]="loanProductCurrencyForm.get('currencyCode')"
        [multiDisburseLoan]="loanProductSettingsForm.get('multiDisburseLoan')"
      >
      </LOSx-loan-product-charges-step>
    </mat-step>

    @if (isAdvancedPaymentStrategy) {
      <mat-step [stepControl]="loanIncomeCapitalizationForm" completed>
        <ng-template matStepLabel>{{ 'labels.inputs.DEFERRED INCOME RECOGNITION' | translate }}</ng-template>
        <LOSx-loan-product-capitalized-income-step
          [deferredIncomeRecognition]="deferredIncomeRecognition"
          [capitalizedIncomeCalculationTypeOptions]="loanProductAndTemplate.capitalizedIncomeCalculationTypeOptions"
          [capitalizedIncomeStrategyOptions]="loanProductAndTemplate.capitalizedIncomeStrategyOptions"
          [capitalizedIncomeTypeOptions]="loanProductAndTemplate.capitalizedIncomeTypeOptions"
          [buyDownFeeCalculationTypeOptions]="loanProductAndTemplate.buyDownFeeCalculationTypeOptions"
          [buyDownFeeStrategyOptions]="loanProductAndTemplate.buyDownFeeStrategyOptions"
          [buyDownFeeIncomeTypeOptions]="loanProductAndTemplate.buyDownFeeIncomeTypeOptions"
          (setViewChildForm)="setViewChildForm($event)"
        >
        </LOSx-loan-product-capitalized-income-step>
        <LOSx-stepper-buttons></LOSx-stepper-buttons>
      </mat-step>
    }

    <mat-step [stepControl]="loanProductAccountingForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.ACCOUNTING' | translate }}</ng-template>

      <LOSx-loan-product-accounting-step
        [loanProductsTemplate]="loanProductAndTemplate"
        [accountingRuleData]="accountingRuleData"
        [loanProductFormValid]="loanProductFormValidAndNotPristine"
        [deferredIncomeRecognition]="deferredIncomeRecognition"
      >
      </LOSx-loan-product-accounting-step>
    </mat-step>

    @if (loanProductFormValidAndNotPristine) {
      <mat-step state="preview" completed>
        <ng-template matStepLabel>{{ 'labels.inputs.PREVIEW' | translate }}</ng-template>
        <LOSx-loan-product-preview-step
          [loanProductsTemplate]="loanProductAndTemplate"
          [accountingRuleData]="accountingRuleData"
          [loanProduct]="loanProduct"
          (submitEvent)="submit()"
        >
        </LOSx-loan-product-preview-step>
      </mat-step>
    }
  </mat-stepper>
</div>
